module.exports = __webpack_public_path__ + "static/media/lobby.a9ce5032.jpg";